import { createIcon } from "@chakra-ui/icons";

export default createIcon({
  displayName: "DropletPercent",
  viewBox: "0 0 320 512",
  path: (
    <path
      d="M186.6 51.36c-7.188-25.27-45-26.36-53.13 0C90.94 189.3 0 226.9 0 324.1c0 86.08 71.56 155.9 160 155.9s160-69.78 160-155.9C320 226.4 229.3 190 186.6 51.36zM80 264c0-13.31 10.69-23.1 24-23.1S128 250.7 128 264S117.3 288 104 288S80 277.3 80 264zM123.3 379.3C120.2 382.4 116.1 383.1 112 383.1s-8.188-1.562-11.31-4.688c-6.25-6.25-6.25-16.37 0-22.62l96-95.1c6.25-6.25 16.38-6.25 22.62 0c6.25 6.25 6.25 16.37 0 22.62L123.3 379.3zM216 399.1c-13.31 0-24-10.69-24-23.1c0-13.31 10.69-23.1 24-23.1s24 10.69 24 23.1C240 389.3 229.3 399.1 216 399.1z"
      fill="currentColor"
    />
  ),
});
